import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  visible: false,
}

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    toggleVisibility(state, action) {
      state.visible = !state.visible
    },
  },
})

export const actions = {
  ...searchSlice.actions,
}

export default searchSlice.reducer
